<div *ngIf="loadErrorKey" class="aca-collabora-error" data-automation-id="collabora-load-error">
  <mat-icon class="aca-collabora-error__icon">error_outline</mat-icon>
  <p class="aca-collabora-error__message">{{ loadErrorKey | translate }}</p>
  <p *ngIf="loadErrorDetail" class="aca-collabora-error__detail">{{ loadErrorDetail }}</p>
  <button mat-stroked-button (click)="onBackButtonClick()">{{ 'COLLABORA.ERROR.BACK' | translate }}</button>
</div>

<div id="collabora-online" class="adf-viewer__fullscreen-container" [hidden]="loadErrorKey">
  <div id="loolcontainer">
    <form #form id="loleafletform" name="loleafletform" method="POST" [action]="iFrameUrl" target="loleafletframe" hidden="hidden">
      <input #access_token type="text" name="access_token" [value]="accessToken">
      <input #access_token_ttl type="text" name="access_token_ttl" [value]="accessTokenTTL">
    </form>
    <iframe #loleafletFrame id="loleafletframe" name="loleafletframe" allowfullscreen="true"></iframe>
  </div>
</div>
